$(document).ready(function(){
  theme.Currency = (function() {
    var moneyFormat = '$'; // eslint-disable-line camelcase

    function formatMoney(cents, format) {
      if (typeof cents === 'string') {
        cents = cents.replace('.', '');
      }
      var value = '';
      var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
      var formatString = format || moneyFormat;

      function formatWithDelimiters(number, precision, thousands, decimal) {
        thousands = thousands || ',';
        decimal = decimal || '.';

        if (isNaN(number) || number === null) {
          return 0;
        }

        number = (number / 100.0).toFixed(precision);

        var parts = number.split('.');
        var dollarsAmount = parts[0].replace(
          /(\d)(?=(\d\d\d)+(?!\d))/g,
          '$1' + thousands
        );
        var centsAmount = parts[1] ? decimal + parts[1] : '';

        return dollarsAmount + centsAmount;
      }

      switch (formatString.match(placeholderRegex)[1]) {
        case 'amount':
          value = formatWithDelimiters(cents, 2);
          break;
        case 'amount_no_decimals':
          value = formatWithDelimiters(cents, 0);
          break;
        case 'amount_with_comma_separator':
          value = formatWithDelimiters(cents, 2, '.', ',');
          break;
        case 'amount_no_decimals_with_comma_separator':
          value = formatWithDelimiters(cents, 0, '.', ',');
          break;
        case 'amount_no_decimals_with_space_separator':
          value = formatWithDelimiters(cents, 0, ' ');
          break;
        case 'amount_with_apostrophe_separator':
          value = formatWithDelimiters(cents, 2, "'");
          break;
      }

      return formatString.replace(placeholderRegex, value);
    }

    return {
      formatMoney: formatMoney
    };
  })();
  
  
  function htmlEncode(value){
    if (value) {
      return $('<div/>').text(value).html();
    } else {
      return '';
    }
  }
  
  function lpgrefreshCart(cart) {
    $(".cart_count").empty();
//     $cartBtn = $(".cart_count");
//     var value = $cartBtn.text() || '0';
    var cart_items_html = "";
    var cart_discounts_html = "";
    var cart_action_html = "";
    var cart_savings_html = "";
    var $cart = $(".custom_cart_content form");
    var discounted_price_total = 0;
    var total_savings = 0;

//     $cartBtn.text(value.replace(/[0-9]+/,cart.item_count));

    if (cart.item_count == 0) {
      $('.js-empty-cart__message').removeClass('hidden');
      $('.js-cart_content__form').addClass('hidden');
    } else {
      $('.js-empty-cart__message').addClass('hidden');
      $('.js-cart_content__form').removeClass('hidden');

      $.each(cart.items, function(index, item) {
        var line_id = index + 1;
        cart_items_html += '<div class="product_row box_padding">' +
          '<div class="product_img">';
        if (item.image) {
          cart_items_html += '<img src="' + item.image.replace(/(\.[^.]*)$/, "_compact$1").replace('http:', '') + '" class="img-fluid lazyload" alt="' + htmlEncode(item.title) + '" />' +
            '</div>';
        }

        cart_items_html += '<div class="product_detail_block"><p class="medium">' + item.title +'</p>';

        if(item.properties) {
          $.each(item.properties, function(title, value) {
            if (title.indexOf("_options_") != -1) { return; }
            if (value) {
              cart_items_html += '<div class="line-item">' + title +': ' + value + '</div>';
            }
          });
        }

        if (item.price > item.final_price) {
          //puts the slash through the old item price
          var itemPrice = theme.Currency.formatMoney(item.final_price, theme.moneyFormat) + '<span class="money was_price">' + theme.Currency.formatMoney(item.price, theme.moneyFormat) + '</span>';
          cart_items_html += '<p class="price_text bold">' + itemPrice + '</p>';
        } else {
          var itemPrice = theme.Currency.formatMoney(item.price, theme.moneyFormat);
          cart_items_html += '<p class="price_text bold">' + itemPrice + '</p>';
        }
        
        cart_items_html += '<div class="qty_counter mt-2"><div class="qty-input">'+
						    '<i class="less">-</i>'+
                            '<input type="text" name="updates[]" class="qty quantity"  id="updates_' + item.id + '" value="' + item.quantity +'" data-line-id="' + line_id +'" value="' + item.quantity +'" >'+
                            '<i class="more">+</i></div></div>';
        
        cart_items_html += '</div>';
        
        cart_items_html += '<div class="remove_text">'+
                        	'<a href="" class="remove_item" data-line-id="' + line_id +'"><i class="material-icons">close</i></a>'+
                      		'</div></div>'
        
      });

      cart_action_html += '<p class="medium">Subtotal</p>' +
        '<p class="price_text bold">' + theme.Currency.formatMoney(cart.total_price, theme.moneyFormat) + '</p>';

    }
    $('.js-cart_items').html(cart_items_html);
    $('.js-cart_subtotal').html(cart_action_html);
  }
  
  
  function lpgajaxUpdateCart(lineID, quantity, parent) {
    $.ajax({
      url: '/cart/change.js',
      dataType: 'json',
      cache: false,
      type: 'post',
      data: { quantity: quantity, line: lineID },
      success: function (data) {
        lpgrefreshCart(data);

        var lineIDIndex = lineID - 1;

        //check to see if there are correct amount of products in array
        if (typeof data.items[lineIDIndex] === "undefined"){
          var updated_quantity = 0;
        } else {
          var updated_quantity = data.items[lineIDIndex].quantity;
        }

        if(quantity > 0 && quantity != updated_quantity) {
          if (updated_quantity == 1) {
            items_left_text = 'item left';
          } else {
            items_left_text = 'items left';
          }

          $('.warning--quantity').remove();

          var warning = '<p class="warning warning--quantity animated bounceIn">' + updated_quantity + ' ' + items_left_text + '</p>';
          parent.find("input[data-line-id='" + lineID + "']").parent().after(warning);
          parent.find("input[data-line-id='" + lineID + "']").val(updated_quantity);
        } else if (parent.is('#cart_form')) {
//           $("#cart_form").submit();
        }
      }
    });
  }
  
  
  $('#SingleOptionSelector-0, #SingleOptionSelector-1, #SingleOptionSelector-2').change(function(){
    var $this = $(this);
    var val0 = $('#SingleOptionSelector-0').val();
    var val1 = $('#SingleOptionSelector-1').val();
    var val2 = $('#SingleOptionSelector-2').val();

    $(this).parents('form').find('.product-single__variants option').removeAttr('selected');
    $(this).parents('form').find('.product-single__variants option').prop('selected',false);
    $(this).parents('form').find('.product-single__variants option').each(function(){
      var s_this = $(this);
      var val =  s_this.attr('data-value');
      var price = s_this.attr('data-price');
      var available = s_this.attr('data-avail');
      
      if(typeof val2 != 'undefined' && typeof val1 != 'undefined' && typeof val0 != 'undefined'){
        if(val == val0+' / '+val1+' / '+val2){
          var var_id = s_this.val();
          s_this.prop('selected',true);
          s_this.attr('selected','selected');
          
          if(available == "true"){
            s_this.parents('form').find('.custom_atc_btn').removeAttr('disabled').text('Add to cart');
          }
          else{
            s_this.parents('form').find('.custom_atc_btn').attr('disabled').text('Sold Out');
          }
          s_this.parents('.product_content').find('.price_text').text(price);

          var newurl = window.location.protocol + '//' + window.location.host + window.location.pathname + '?variant=' + s_this.val();
          window.history.replaceState({path: newurl}, '', newurl);
        }
      }
      else if(typeof val2 == 'undefined' && typeof val1 != 'undefined' && typeof val0 != 'undefined'){
        if(val == val0+' / '+val1){
          var var_id = s_this.val();
          s_this.prop('selected',true);
          s_this.attr('selected','selected');
          
          if(available == "true"){
            s_this.parents('form').find('.custom_atc_btn').removeAttr('disabled');
            s_this.parents('form').find('.custom_atc_btn').html('Add to cart'+'<i class="material-icons">arrow_forward</i>');
          }
          else{
            s_this.parents('form').find('.custom_atc_btn').html('Sold Out'+'<i class="material-icons">arrow_forward</i>');
            s_this.parents('form').find('.custom_atc_btn').attr('disabled');
          }
          s_this.parents('.product_content').find('.price_text').text(price);

          var newurl = window.location.protocol + '//' + window.location.host + window.location.pathname + '?variant=' + s_this.val();
          window.history.replaceState({path: newurl}, '', newurl);
        }
      }
      else{
        if(val == val0){
          var var_id = s_this.val();
          s_this.prop('selected',true);
          s_this.attr('selected','selected');
          
          if(available == "true"){
            s_this.parents('form').find('.custom_atc_btn').removeAttr('disabled').text('Add to cart');
          }
          else{
            s_this.parents('form').find('.custom_atc_btn').attr('disabled').text('Sold Out');
          }
          s_this.parents('.product_content').find('.price_text').text(price);

          var newurl = window.location.protocol + '//' + window.location.host + window.location.pathname + '?variant=' + s_this.val();
          window.history.replaceState({path: newurl}, '', newurl);
        }
      }
    });
  });
  
  
  $('.custom_atc_btn').on('click', function(e){
    e.preventDefault();
    
    var $this = $(this);
    var form = $(this).parents('.shopify-product-form');

    $.ajax({
      type: "POST",
      url: "/cart/add.js",
      dataType: "json",
      data: form.serialize(),
      beforeSend: function() {
      },
      success: function(cart) {
        
        $.ajax({
          url: '/cart.js',
          dataType: "json",
          cache: false,
          success: function(cart) {
            setTimeout(function() {
              lpgrefreshCart(cart);
              $('.shopping_icon').trigger('click');
            }, 500);
          }
        });
        
      }
    });
  });

  $('body').on('click', '.js-cart_content__form .qty-input i', function(e) {
    e.preventDefault();
    
    var val = parseInt($(this).parents('.qty-input').find('input').attr('value'));

    if ($(this).hasClass('less')) {
      if (val != 1) {
        val = val - 1;
      }
    } else if ($(this).hasClass('more')) {
      val = val + 1;
    }
    
    $(this).parent('.qty-input').find('input').attr('value', val);
    lpgajaxUpdateCart($(this).parents('.qty-input').find('input.quantity').data('line-id'), $(this).parents('.qty-input').find('input.quantity').attr('value'), $(this).parents('.cart_icon'));
  });
  
  $('body').on('click', '.remove_item', function(e){
    e.preventDefault();
    
    lpgajaxUpdateCart($(this).data('line-id'), 0, $(this).parents('.cart_icon'));
  });
});